import NumberInput from '@standardsdigital/ui-components/NumberInput';
import styles from './EditableNumberCell.module.css';

interface EditableNumberCellProps {
  isEditing: boolean;
  value: number;
  label: string;
  name: string;
  hasError?: boolean;
  message?: string;
  onValueChange: (value: number) => void;
}

function EditableNumberCell({
  isEditing,
  value,
  label,
  name,
  hasError = false,
  message,
  onValueChange,
}: Readonly<EditableNumberCellProps>) {
  if (isEditing) {
    return (
      <div className={styles.input}>
        <NumberInput
          value={value}
          onChange={(event) => onValueChange(Number(event.target.value))}
          label={label}
          invisibleLabel
          inputSize="small"
          name={name}
          message={message}
          severity={hasError ? 'danger' : undefined}
        />
      </div>
    );
  }

  return <span>{value}</span>;
}

export default EditableNumberCell;
